<template>
  <div class="showcase container-fluid p-0">
    <div class="row no-gutters d-flex d-md-none">
      <div class="showcase-head">
        <h2>リズムだけ入力する</h2><h2>メトロノーム</h2>
      </div>
      <div class="showcase-img">
        <img src="img/display.png" />
      </div>
      <div class="showcase-text">
        <p class="lead mx-3">
          <span class="d-inline-block">Rhythm Readerは</span>
          <span class="d-inline-block">楽譜を見てもわからないような</span>
          <span class="d-inline-block">リズムを簡単に打ち込んで、</span>
          <span class="d-inline-block">音にして聞くことのできる</span>
          <span class="d-inline-block">音楽練習用アプリです。</span>
        </p>
      </div>
    </div>
    
    <div class="row no-gutters d-none d-md-flex">
      <div class="showcase-md-head col-md-6">
        <h2>リズムだけ入力する</h2><h2>メトロノーム</h2>
        <p class="lead mx-3 my-5">
          <span class="d-inline-block">Rhythm Readerは</span>
          <span class="d-inline-block">楽譜を見てもわからないような</span>
          <span class="d-inline-block">リズムを簡単に打ち込んで、</span>
          <span class="d-inline-block">音にして聞くことのできる</span>
          <span class="d-inline-block">音楽練習用アプリです。</span>
        </p>
      </div>
      <div class="showcase-md-img col-md-6">
        <img src="img/display.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lead'
}
</script>

<style scoped>
.showcase{
  margin: 3rem auto 1rem;
}
.showcase-head{
  margin: 0 auto 0.5rem;
}
.showcase-head h2{
  display: inline-block;
  margin: 0;
}
.showcase-text{
  margin: 0 auto;
  padding: 1rem 0 3rem;
}

.showcase-img{
  margin: 0 auto;
  padding: 1rem 15%;
}
.showcase-img img{
  width: 100%;
  max-width: 300px;
  box-shadow: 0 0 6px 3px rgba(0,0,0,0.2);
}

.showcase-md-head{
  margin: 2rem -5% 2rem 5%;
}
.showcase-md-img{
  margin: 0.25rem 5% 0.25rem -5%;
}

.showcase-md-img img{
  width: 100%;
  max-width: 300px;
  box-shadow: 0 0 6px 3px rgba(0,0,0,0.2);
}


</style>